import { type AiBuilderMessage } from '../store';
import { AiBuilderChatMessageAI } from './AiBuilderChatMessageAI';
export const AiBuilderProgressMessage = ({
  message
}: {
  message: Extract<AiBuilderMessage, {
    kind: 'progress';
  }>;
}) => {
  return <AiBuilderChatMessageAI data-sentry-element="AiBuilderChatMessageAI" data-sentry-component="AiBuilderProgressMessage" data-sentry-source-file="AiBuilderProgressMessage.tsx">
      <AiBuilderChatMessageAI.Progress message={message} data-sentry-element="unknown" data-sentry-source-file="AiBuilderProgressMessage.tsx" />
    </AiBuilderChatMessageAI>;
};